/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerFilterComponent', [
    '$timeout',
    'DesignerComponent',

    function ($timeout, DesignerComponent) {
      function DesignerFilterComponent() {
        DesignerComponent.apply(this);
      }

      DesignerFilterComponent.prototype = new DesignerComponent();

      DesignerFilterComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.defaults(this, this.defaults);

        const predicates = {};
        predicates.match_type = this.predicates.match_type;
        predicates.expressions = this.predicates.expressions;

        _.extend(data, {
          predicates,
        });

        return data;
      };

      DesignerFilterComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerFilterComponent.prototype.setData = function (data) {
        this.predicates = data.predicates;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerFilterComponent.prototype.getSchema = function () {
        const schema = DesignerComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerFilterComponent;
    },
  ]);
})(window.angular);
